






































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import {mixin as clickaway} from 'vue-clickaway';
import Rule from './Rule.vue';
import AddIcon from 'vue-material-design-icons/Plus.vue';
import {RuleViewModel} from '../../models/ruleViewModel';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import {RuleConditionsManager} from '@/features/bots/components/rules/ruleConditionsManager';
import {ConfiguredAppIntegration} from '@/features/apps/shared/models/configuredAppIntegration';
import TagBox from '@/shared/components/TagBox.vue';
import CapableAppPicker from '@/shared/components/capableAppPicker/CapableAppPicker.vue';
import {ConfigRequest} from '@/shared/components/capableAppPicker/configRequest';
import {BotActionAppViewModel} from '@/features/bots/models';

@Component({
	mixins: [
		clickaway,
	],
	components: {
		Rule,
		TagBox,
		CapableAppPicker,
		AddIcon
	}
})
export default class RulesList extends Vue {
	@Prop() public configRequest!: ConfigRequest;
	@Prop() public rules!: RuleViewModel[];
	@Prop() public selectedApps!: Array<ConfiguredAppIntegration | undefined>;
	@Prop() public ruleConditionsManager!: RuleConditionsManager;

	@Getter public currentWorkspace!: WorkspaceViewModel;
	public providedRules: RuleViewModel[] = [];
	public ruleInvalidStates: boolean[] = [];
	public hasInvalidRuleConditions: boolean = false;

	@Watch('rules', {immediate: true, deep: true})
	public onValueChanged(value: RuleViewModel[]) {
		if (value && value.length > 0) {
			this.providedRules = value;
		}
	}

	public addRule() {
		const rule = {
			conditions: {
				type: 'and',
				conditions: []
			},
			actions: []
		};
		this.providedRules.push(rule);
		this.ruleUpdated(this.providedRules.length - 1, rule, this.hasAnyInvalidRules());
	}

	public ruleUpdated(index: number, rule: RuleViewModel, hasInvalidConditions: boolean, ) {
		this.providedRules[index] = rule;
		this.ruleInvalidStates[index] = hasInvalidConditions;
		this.hasInvalidRuleConditions = this.hasAnyInvalidRules();

		this.$emit('rules-updated', this.providedRules);
	}

	public selectedFollowUpActionsChanged(selectedApps: BotActionAppViewModel[]) {
		this.$emit('followup-action-change', selectedApps);
	}

	public deleteRule(index: number) {
		this.providedRules.splice(index, 1);
	}

	public areRulesAreValid(): boolean {
		if (this.hasInvalidRuleConditions) {
			return false;
		}

		for (let i = 0; i < this.rules.length; i++) {
			const componentName = `rule-component-${i}`;
			if (!this.ruleIsValid(componentName)) {
				return false;
			}
		}
		return true;
	}

	private hasAnyInvalidRules() {
		return this.ruleInvalidStates.some(invalid => invalid);
	}

	private ruleIsValid(componentName: string) {
		const component = (this.$refs[componentName]as any)[0] as Rule;
		if (component) {
			(component.$v as any).providedRule.$touch();
			if (component.$v.$anyError) {
				return false;
			}
		}
		return true;
	}
}
